import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { isStaff } from '@utils/getRole';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const customerDeliveryFileRegisterService = (
  data: {
    subject: string;
    otmSt: string;
    expirationYmd: string;
    authPwd: string;
  },
  signal?: AbortSignal,
) => {
  const URL = isStaff
    ? ENDPOINTS.STAFF.CUSTOMER_DELIVERY.CREATE_FILE
    : ENDPOINTS.ADMIN.CUSTOMER_DELIVERY.CREATE_FILE;

  return axiosInstance
    .post(URL, data, { signal })
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
